import { DEFAULT_CURRENCY_ABREVIATURE } from "features/Contactos/constants/index"

export const newDocumentoSettingsSelector = (state: $TSMigrationFixMe) =>
  state.newDocumentoSettings

export const getNewDocumentCurrency = (state: $TSMigrationFixMe) =>
  state.documentos.currency

export const getDefaultCurrency = (state: $TSMigrationFixMe) => {
  const { divisaAbreviatura = DEFAULT_CURRENCY_ABREVIATURE } =
    state.user.empresaActiva

  return divisaAbreviatura
}

export const getDefaultCountry = (state: $TSMigrationFixMe) => {
  const { pais } = state.user.empresaActiva

  return pais
}
